var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list.lenght > 0)?_c('CouponList',{ref:"CouponList",attrs:{"list":_vm.list},on:{"getCouponList":_vm.getCouponList}}):_c('NoData',{attrs:{"text":"暂无优惠券可用","empty":_vm.empty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }